import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

import { normalizeRichTextHtml as normalizeRichTextHtmlImpl, stripHtmlToPlainText } from '@/lib/rich-text';

/** @deprecated Prefer prepareRichTextHtml from @/lib/rich-text for rendering. */
export function normalizeRichTextHtml(html: string) {
  return normalizeRichTextHtmlImpl(html);
}

/** Safely parse JSON stored in DB (settings, Person fields, Service arrays, etc.) */
export function parseJsonField<T = unknown>(raw: string | null | undefined, fallback: T): T {
  if (!raw?.trim()) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

/** @deprecated Use parseJsonField */
export const parseSettingsJson = parseJsonField;

export function stripHtml(html: string) {
  return stripHtmlToPlainText(html);
}
